import gql from 'graphql-tag'

const furnitureFragment = gql`
	fragment furnitureFragment on Furniture {
		id
		mod_ver
		projectId
		floorId
		roomId
		objectType
		objectKind
		caption
		componentColor
		positionTop
		positionLeft
		rotationDeg
		height
		width
		shape
	}
`

export const rawCreateProject = gql`
mutation createProject($defaultRoomCaption: String!, $caption: String!){
	cashAssist {
		createProject (defaultRoomCaption: $defaultRoomCaption, caption: $caption){
			objectType
			caption
			id
			floors {
				id
				projectId
				rooms {
					id
					projectId
					floorId
				}
			}
    	}
  	}
}
`

export const rawCreateFloor = gql`
mutation createFloor($fields: CreateFloorFields!, $defaultRoomCaption: String!){
	cashAssist {
		createFloor(fields: $fields, defaultRoomCaption: $defaultRoomCaption){
			id
			projectId
			number
			objectType
			rooms {
				id
				projectId
				floorId
				caption
				mod_ver
				objectType
			}
		}
 	}
}
`

export const rawCreateRoom = gql`
mutation createRoom($fields: CreateRoomFields!){
	cashAssist {
		createRoom(fields: $fields){
			objectType
			caption
			id
			projectId
			floorId
			mod_ver
			furniture {
				...furnitureFragment
			}
		}
	}
}
${furnitureFragment}`

export const rawUpdateProject = gql`
mutation updateProject($fields: UpdateProjectFields!){
	cashAssist {
		updateProject(fields: $fields){
			objectType
			caption
			id
			mod_ver
			floors{
				objectType
				number
				projectId
				id
				mod_ver
				rooms {
					objectType
					caption
					projectId
					floorId
					id
					mod_ver
					furniture {
						...furnitureFragment
					}
				}
			}
		}
	}
}
${furnitureFragment}`

export const rawUpdateFloor = gql`
mutation updateFloor($fields: [UpdateFloorFields]!){
	cashAssist {
		updateFloor(fields: $fields){
			id
			projectId
			number
			objectType
			rooms {
				objectType
				caption
				id
				projectId
				floorId
				mod_ver
				furniture {
					...furnitureFragment
				}
		    }
		}
	}
}
${furnitureFragment}`

export const rawUpdateRoom = gql`
mutation updateRoom($fields: [UpdateRoomFields]!){
	cashAssist {
	 updateRoom(fields: $fields){
			objectType
			caption
			id
			projectId
			floorId
			mod_ver
			roomColor
			furniture {
				...furnitureFragment
			}
	 	}
	}
}
${furnitureFragment}`

export const rawCreateFurniture = gql`
    mutation createFurniture($fields: [CreateFurnitureFields]!) {
    	cashAssist {
			createFurniture(fields: $fields) {
				...furnitureFragment
			}   
		}
  } 
${furnitureFragment}`

export const rawUpdateFurniture = gql`
     mutation updateFurniture($fields: [UpdateFurnitureFields]!) {
     	cashAssist {
			updateFurniture(fields: $fields) {
				...furnitureFragment
			}   
      	}
  } 
${furnitureFragment}`

export const rawDeleteFurniture = gql`
      mutation deleteFurniture($ids: [ID]!) {
      	cashAssist {
			deleteFurniture(ids: $ids)  
		}
  } 
`


export const rawDeleteProject = gql`
mutation deleteProject($id: ID!){
	cashAssist {
	 	deleteProject(id: $id)
	}
}
`
export const rawDeleteFloor = gql`
mutation deleteFloor($id: ID!){
	cashAssist {
	 	deleteFloor(id: $id)
	}
}
`
export const rawDeleteRoom = gql`
mutation deleteRoom($id: ID!){
	cashAssist {
	 	deleteRoom(id: $id)
	}
}
`
